import { Suspense } from 'react'

import { styled } from 'styled-components'

import { Spinner } from 'core/components'
import lazyWithRetry from 'core/system/lazyWithRetry'

const LazyAdminApp = lazyWithRetry(() => import('admin/AdminApp'))

const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
`

const fallback = (
  <SpinnerContainer>
    <Spinner />
  </SpinnerContainer>
)

const AdminRoutes = () => (
  <Suspense fallback={fallback}>
    <LazyAdminApp />
  </Suspense>
)

export default AdminRoutes
